import { Form } from 'react-bootstrap'
import { CustomSpinner } from '../CustomSpinner'
import { Center } from '../Center'

export function CustomLoadSelect({
  label,
  value,
  options,
  isLoading,
  ...rest
}) {
  return (
    <>
      <Form.Label>
        {isLoading ? (
          <Center>
            {label} {isLoading && <CustomSpinner size={20} />}
          </Center>
        ) : (
          <>
            {label} {isLoading && <CustomSpinner size={20} />}
          </>
        )}
      </Form.Label>

      <Form.Select
        value={value}
        disabled={isLoading}
        {...rest}
      >
        <option value="">
          {isLoading ? 'Carregando...' : 'Não Selecionado'}
        </option>

        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
          >
            {opt.label}
          </option>
        ))}
      </Form.Select>
    </>
  )
}
